<form [formGroup]="callbackFormGroup">
    <div class="flex-r a-center m-bottom-small">
        <div>
            <img alt="secretary-image" [src]="IMG.SECRETARY | imageSrc"/>
        </div>
        <div class="secretary-question">{{ callbackQuestion() }}</div>
    </div>
    <div class="flex-c">
        <!-- suggestion -->
        <div class="highlight cft-border-blue container-p m-bottom-big">
            <!-- already selected suggestion -->
            <div [ngClass]="{ 'hide-suggestion': isEditMode() }">
                <div class="flex-r a-center cft-border selected-suggestion p-mid" (click)="toggleView()">
                    <div>{{ selectedSuggestion() }}</div>
                </div>

                <button (click)="toggleView()" class="cft-button m-top-big" matButton="outlined">
                    <mat-icon [svgIcon]="ICONS.AIDA"></mat-icon>
                    {{ I18N.ALTERNATIVE_SUGGESTIONS | i18n | async }}
                </button>
            </div>

            <!-- expandable container -->
            <div class="suggestion" [ngClass]="{ active: isEditMode() }">
                <mat-form-field class="input-suggestion" appearance="outline">
					<textarea
                            [formControl]="customSuggestionCtrl"
                            matInput
                            [maxlength]="MAX_LENGTH_CUSTOM_SUGGESTION"
                            [cdkTextareaAutosize]="true"
                            [cdkAutosizeMinRows]="3"
                            [cdkAutosizeMaxRows]="5"
                            placeholder="{{ I18N.CALLBACK_QUESTION_CONTENT | i18n | async }} "
                    >
					</textarea>
                    @if (customSuggestionCtrl.hasError('required')) {
                        <mat-error>{{ I18N.ERROR_REQUIRED | i18n | async }}</mat-error>
                    } @else if (customSuggestionCtrl.hasError('maxlength')) {
                        <mat-error>{{ I18N.ERROR_MAX_LENGTH | i18n | async }}</mat-error>
                    }
                </mat-form-field>
                <div class="flex-r cft-border p-mid m-top-mid"
                     [ngClass]="{ 'is-hidden': callbackCreated ||  callbackCreationFailed }">
                    <div class="m-right-mid">
                        <img class="ai-img" alt="ai-image" [src]="IMG.AIDA | imageSrc"/>
                    </div>
                    <mat-radio-group
                            aria-labelledby="example-radio-group-label"
                            class="flex-c suggestion-group"
                            [formControl]="aiSuggestionCtrl"
                    >
                        @for (suggestion of suggestions; track suggestion.id) {
                            <mat-radio-button [value]="suggestion.id">{{
                                    suggestion.suggestion
                                }}
                            </mat-radio-button>
                        }
                    </mat-radio-group>
                </div>
            </div>
        </div>

        <!-- ./suggestion -->
        <!-- callback time selection -->
        <div
                class="m-bottom-big highlight cft-border cft-border-blue callback-text container-p schedule-options"
        >
            <mat-label class="schedule-options__title">{{
                    I18N.CALLBACK_QUESTION_TIME | i18n | async
                }}
            </mat-label>
            <div class="callback-info m-top-mid p-mid">
                <div>{{
                        I18N.CALLBACK_TIME_INFORMATION | i18n | async
                    }}

                    @if (businessHoursInformation().length === 1) {
                        ( {{ businessHoursInformation()![0] }} )
                    }
                </div>
                @if (businessHoursInformation().length > 1) {
                    @for (businessHourInformation of businessHoursInformation(); track $index) {
                        <div>{{ businessHourInformation }}</div>
                    }
                }
            </div>
            <mat-radio-group [formControl]="selectedScheduleOptionCtrl"
                             class="schedule-options__list">
                @for (opt of scheduleOptions; track opt.value) {
                    <mat-radio-button [value]="opt.value">
                        {{ opt.translationKey | i18n | async }}
                        @if (opt.value === scheduleOption.IMMEDIATE && !!soonDate()) {
                            <span class="earliest"> ( {{ I18N.EARLIEST | i18n | async }} {{ soonDate() }} )</span>
                        }
                    </mat-radio-button>
                }
            </mat-radio-group>

            <!--custom date and time-->
            @if (selectedScheduleOptionCtrl.value === 'specific_date_time') {
                <div class="date-time">
                    <mat-form-field appearance="outline" class="date-picker">
                        <input
                                readonly
                                matInput
                                [formControl]="dateCtrl"
                                [matDatepicker]="datepicker"
                                [matDatepickerFilter]="dateFilter"
                                (click)="datepicker.open()"
                        />
                        <mat-datepicker #datepicker appearance="outline"/>
                        <mat-datepicker-toggle [for]="datepicker" matSuffix/>
                        @if (scheduleFormGroup.hasError('dateRequired')) {
                            <mat-error>{{ I18N.ERROR_REQUIRED | i18n | async }}</mat-error>
                        } @else if (scheduleFormGroup.hasError('dayInPast')) {
                            <mat-error>{{ I18N.ERROR_PAST_DATE | i18n | async }}</mat-error>
                        } @else if (scheduleFormGroup.hasError('matDatepickerParse')) {
                            <mat-error>{{ I18N.ERROR_INVALID_DATE | i18n | async }}</mat-error>
                        } @else if (scheduleFormGroup.hasError('notBusinessDay')) {
                            <mat-error>{{ I18N.ERROR_NO_BUSINESS_DAY | i18n | async }}</mat-error>
                        }
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="time-picker">
                        <input
                                matInput
                                [formControl]="timeCtrl"
                                [matTimepicker]="timepicker"
                                [matTimepickerMin]="minStartTime()"
                                [matTimepickerMax]="maxEndTime()"
                        />
                        <mat-timepicker #timepicker/>
                        <mat-timepicker-toggle [for]="timepicker" matSuffix/>
                        @if (scheduleFormGroup.hasError('notBusinessHour')) {
                            <mat-error>{{ I18N.ERROR_NO_BUSINESS_DAY | i18n | async }}</mat-error>
                        } @else if (scheduleFormGroup.hasError('timeInPast')) {
                            <mat-error>{{ I18N.ERROR_PAST_DATE | i18n | async }}</mat-error>
                        }
                    </mat-form-field>
                    <div class="help-icon">
                        <mat-icon
                                class="material-icons-outlined"
                                matTooltipClass="business-hour-tooltip"
                                matTooltipPosition="right"
                                [matTooltip]="businessHoursTooltip"
                        >help_outline
                        </mat-icon
                        >
                    </div>
                </div>
            }
            <!--./custom date and time-->
            @if (nighttimeWarning()) {
                <div class="time-warning flex-r a-center m-top-mid p-mid">
                    <mat-icon class="material-icons-outlined">warning
                    </mat-icon
                    >
                    {{ I18N.TIME_WARNING | i18n | async }}
                </div>
            }

        </div>
        <!-- ./callback time selection -->

        <!-- who handles the call: AI vs Agent (EB-4016) — shown only when the backend offers modes -->
        @if (showVoiceBotMode()) {
            <div
                    class="m-bottom-big highlight cft-border cft-border-blue callback-text container-p schedule-options"
            >
                <mat-label class="schedule-options__title">{{
                        I18N.VOICE_BOT_MODE_LABEL | i18n | async
                    }}
                </mat-label>
                <mat-radio-group [formControl]="voiceBotModeCtrl" class="schedule-options__list">
                    @for (mode of voiceBotModeOptions(); track mode) {
                        <mat-radio-button [value]="mode">
                            {{ voiceBotModeLabelKey(mode) | i18n | async }}
                        </mat-radio-button>
                    }
                </mat-radio-group>
            </div>
        }
        <!-- ./who handles the call -->

        <!-- accept voicemail als last attempt  -->
<!--        <div-->
<!--                class="m-bottom-big highlight cft-border cft-border-blue callback-text container-p schedule-options"-->
<!--        >-->
<!--            <mat-slide-toggle-->
<!--                    [formControl]="voicemailAllowedCtrl"-->
<!--            ><span class="m-left-mid">{{ I18N.ACCEPT_VOICEMAIL | i18n | async }}</span></mat-slide-toggle>-->
<!--        </div>-->
        <!-- ./accept voicemail als last attempt -->
    </div>
    @if (callbackCreated) {
        <app-success></app-success>
    }
    @if (callbackCreationFailed) {
        <app-error-callback-creation></app-error-callback-creation>
    }
    @if (existingOutboundTask()) {
        <div class="existing-task-panel highlight cft-border cft-border-blue container-p m-top-mid">
            <div class="existing-task-panel__header flex-r a-center">
                <mat-icon class="material-icons-outlined">info</mat-icon>
                <div class="existing-task-panel__message">
                    @if (existingTaskTranslationKey()) {
                        {{ existingTaskTranslationKey() | i18n | async }}
                    }
                </div>
            </div>
            <!-- <div class="existing-task-panel__details">
                <div class="label">Status:</div>
                <div class="value">{{ existingOutboundTask()?.status }}</div>
            </div> -->
        </div>
    }
    <div class="action-bar flex-r">
        <button (click)="showInfos()" class="cft-button-large" matButton="outlined">
            {{ I18N.INFO_PRICE_BTN | i18n | async }}
        </button>
        <!--		TODO: disabling is not a good idea as form validation for instruction is not triggered-->
        @if (!callbackCreated && !callbackCreationFailed) {
            <!-- PS-6495: a suspended setup run is resumed by this same button, so its label says so
                 rather than pretending the call can go out. -->
            <button
                    [disabled]="hasExistingTask() || setupDialogOpen() || callbackInFlight()"
                    (click)="triggerOutboundCall()"
                    class="cft-button-right-large"
                    matButton="filled"
            >
                @if (setupInProgress) {
                    {{ I18N.SIP_RESUME_BTN | i18n | async }}
                } @else {
                    {{ I18N.CALL_BTN | i18n | async }}
                }
            </button>
        }

    </div>
</form>
